import React from "react";
import { Outlet } from "react-router-dom";
import { X, Bot, Wrench, FolderOpen, ScrollText, Settings } from "lucide-react";
import { Tabs, type Tab } from "@ui";
import { AdminChatProvider } from "@agentic_system/contexts/admin-chat-context";

const tabs: Tab[] = [
  { to: "/system/agentic/logs", label: "Logs", icon: ScrollText },
  { to: "/system/agentic/agents", label: "Agents", icon: Bot, alsoMatches: ["/system/agentic/agents/"] },
  { to: "/system/agentic/system-prompt", label: "Prompt système", icon: Settings, alsoMatches: ["/system/agentic/system-prompt/"] },
  { to: "/system/agentic/tools", label: "Tools", icon: Wrench },
  { to: "/system/agentic/files", label: "Files", icon: FolderOpen },
];

export function Layout() {
  return (
    <AdminChatProvider>
      <div data-testid="layout" className="w-full h-full flex flex-col min-h-0">
        <header className="flex-shrink-0 py-2 bg-white border-b border-slate-200 flex items-center justify-between px-6">
          <div className="flex items-center gap-6">
            <h1 className="text-xl font-semibold text-slate-800">
              Gestion AI
            </h1>
            <Tabs tabs={tabs} />
          </div>

          <div className="flex items-center gap-3">
            <a
              href="/system"
              className="flex items-center gap-2 px-4 py-2 text-sm text-slate-600 hover:text-slate-800 hover:bg-slate-100 rounded-lg transition-colors"
            >
              <X className="w-4 h-4" />
              Exit
            </a>
          </div>
        </header>

        <div className="flex flex-col h-full flex-shrink min-h-0">
          <Outlet />
        </div>
      </div>
    </AdminChatProvider>
  );
}
